import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Checkbox,
  Label,
  Dropdown,
  Button
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardReportPatientListUX = (props: any) => {
    return(
      <div
        id="CardReportPatientListUX-div-0"
        style={{ margin: "10px" }}>
        <div
          className="ui form"
          id="CardReportPatientListUX-div-1">
          
          <FormGroup
            id="CardReportPatientListUX-FormGroup-2"
            inline={true}>
            <FormField
              id="CardReportPatientListUX-FormField-3"
              inline={true}>
              <Checkbox
                checked={props.filter?.isHN || false}
                id="CardReportPatientListUX-Checkbox-8"
                label={props.languageUX === "en" ? "HN" : "เอชเอ็น"}
                name="isHN"
                onChange={props.onChangeValue}
                style={{fontWeight: "bold"}}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardReportPatientListUX-FormField-4"
              inline={true}
              width={3}>
              <div
                id="CardReportPatientListUX-div-9"
                style={{width: "100%"}}>
                {props.PatientSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardReportPatientListUX-FormField-5"
              inline={true}>
              <label
                id="CardReportPatientListUX-label-10"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Patient's name and surname" : "ชื่อ-สกุลผู้ป่วย"}
              </label>
            </FormField>
            <FormField
              id="CardReportPatientListUX-FormField-6">
              <Label
                id="CardReportPatientListUX-Label-11"
                size="large"
                style={{ minWidth: "max-content", width: "10rem", padding:"0.833em"}}>
                {props.fullName || "-"}
              </Label>
            </FormField>
            <FormField
              id="CardReportPatientListUX-FormField-7">
              <label
                id="CardReportPatientListUX-label-15"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Type of patient" : "ประเภทผู้ป่วย"}
              </label>
            </FormField>
            <FormField
              id="CardReportPatientListUX-FormField-12"
              width={2}>
              <Dropdown
                fluid={true}
                id="CardReportPatientListUX-Dropdown-17"
                name="patientCase"
                onChange={props.onChangeValue}
                options={props.patientCaseOptions || []}
                selection={true}
                style={{width: "100%", minWidth: "max-content"}}
                value={props.filter?.patientCase || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardReportPatientListUX-FormField-13"
              inline={true}>
              <label
                id="CardReportPatientListUX-label-16">
                {props.languageUX === "en" ? "clinic" : "คลินิก"}
              </label>
            </FormField>
            <FormField
              id="CardReportPatientListUX-FormField-14"
              inline={true}
              width="3">
              <div
                id="CardReportPatientListUX-div-18"
                style={{width: "100%"}}>
                {props.ClinicSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardReportPatientListUX-FormField-19">
              <label
                id="CardReportPatientListUX-label-22"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Visit Type" : "ประเภท Visit"}
              </label>
            </FormField>
            <FormField
              id="CardReportPatientListUX-FormField-20">
              <Checkbox
                checked={props.filter?.isOPD || false}
                id="CardReportPatientListUX-Checkbox-23"
                label={props.languageUX === "en" ? "OPD" : "ผู้ป่วยนอก"}
                name="isOPD"
                onChange={props.onChangeValue}
                style={{fontWeight: "bold"}}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardReportPatientListUX-FormField-21">
              <Checkbox
                checked={props.filter?.isIPD || false}
                id="CardReportPatientListUX-Checkbox-24"
                label={props.languageUX === "en" ? "IPD" : "ผู้ป่วยใน"}
                name="isIPD"
                onChange={props.onChangeValue}
                style={{fontWeight: "bold"}}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardReportPatientListUX-FormField-25">
              <Button
                color="yellow"
                id="CardReportPatientListUX-Button-26"
                onClick={props.onClear}
                size="small"
                style={{ minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Clear search" : "ล้างการค้นหา"}
              </Button>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardReportPatientListUX-FormGroup-27"
            inline={true}>
            <FormField
              id="CardReportPatientListUX-FormField-28"
              inline={true}>
              <Checkbox
                checked={props.filter?.isDoctor ||false}
                id="CardReportPatientListUX-Checkbox-37"
                label={props.languageUX === "en" ? "The attending physician" : "แพทย์เจ้าของไข้"}
                name="isDoctor"
                onChange={props.onChangeValue}
                style={{fontWeight: "bold", minWidth: "max-content"}}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardReportPatientListUX-FormField-29"
              inline={true}
              width={2}>
              <div
                id="CardReportPatientListUX-div-38"
                style={{width: "100%"}}>
                {props.DoctorSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardReportPatientListUX-FormField-30"
              inline={true}>
              <Checkbox
                checked={props.filter?.isDiagnosis ||false}
                id="CardReportPatientListUX-Checkbox-63"
                label={props.languageUX === "en" ? "Diagnosis" : "การวินิจฉัย"}
                name="isDiagnosis"
                onChange={props.onChangeValue}
                style={{fontWeight: "bold", minWidth: "max-content"}}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardReportPatientListUX-FormField-31"
              inline={true}
              width={3}>
              <div
                id="CardReportPatientListUX-div-40"
                style={{width: "100%"}}>
                {props.DiagnosisSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardReportPatientListUX-FormField-32"
              inline={true}>
              <label
                id="CardReportPatientListUX-label-41"
                style={{ minWidth: "max-content"}}>
                {props.languageUX === "en" ? "date" : "วันที่"}
              </label>
            </FormField>
            <FormField
              id="CardReportPatientListUX-FormField-33"
              inline={true}>
              <div
                id="CardReportPatientListUX-div-57"
                style={{width: "100%"}}>
                {props.StartDate}
              </div>
            </FormField>
            <FormField
              id="CardReportPatientListUX-FormField-34"
              inline={true}>
              <label
                id="CardReportPatientListUX-label-43">
                {props.languageUX === "en" ? "to" : "ถึง"}
              </label>
            </FormField>
            <FormField
              id="CardReportPatientListUX-FormField-35"
              inline={true}>
              <div
                id="CardReportPatientListUX-div-56"
                style={{width: "100%"}}>
                {props.EndDate}
              </div>
            </FormField>
            <FormField
              id="CardReportPatientListUX-FormField-36"
              inline={true}>
              <div
                id="CardReportPatientListUX-div-58">
                {props.ButtonSearch}
              </div>
            </FormField>
            <FormField
              id="CardReportPatientListUX-FormField-45"
              inline="true">
              <div
                id="CardReportPatientListUX-div-59">
                {props.ButtonPrint}
              </div>
            </FormField>
            <FormField
              id="CardReportPatientListUX-FormField-46"
              inline="true">
              <div
                id="CardReportPatientListUX-div-60">
                {props.ButtonStatistic}
              </div>
            </FormField>
            <FormField
              id="CardReportPatientListUX-FormField-47">
              <div
                id="CardReportPatientListUX-div-61">
                {props.ButtonStatisticPrint}
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardReportPatientListUX-div-53">
          
          <Table
            data={props.orderItems || []}
            headers="วันที่รับเข้า,คลินิก/Ward,HN (VN/AN),ชื่อ-นามสกุล,ประเภทผู้ป่วย,ประเภท Visit, แพทย์เจ้าของใข้,Diagnosis"
            id="CardReportPatientListUX-Table-54"
            keys="encounter_datetime,division_name,hn_encounter_number,patient_fullname,patient_case_name,encounter_general_type,doctor_name,icd10_name"
            showPagination={false}
            style={{height: "calc(100vh - 16rem)", display: props.showStatistic ? "none": ""}}
            widths="120">
          </Table>
          <Table
            data={props.statItems || []}
            headers="ลำดับ,แพทย์เจ้าของไข้,ประเภทผู้ป่วย,ประเภท Visit,Diagnosis, จำนวน"
            id="CardReportPatientListUX-Table-62"
            keys="no,doctor_name,patient_case_name,encounter_general_type,icd10_name, encounter_count"
            showPagination={false}
            style={{height: "calc(100vh - 16rem)", display: props.showStatistic ? "": "none"}}
            widths="100,auto,auto,auto,auto,150">
          </Table>
        </div>
      </div>
    )
}

CardReportPatientListUX.displayName = "CardReportPatientListUX";
export default React.memo(CardReportPatientListUX)

export const screenPropsDefault = {}

/* Date Time : Wed Oct 01 2025 12:59:48 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"10px\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-div-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormGroup-2"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormField-3"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormField-4"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormField-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormField-6"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormField-7"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "Checkbox",
      "parent": 3,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filter?.isHN || false"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-Checkbox-8"
        },
        "label": {
          "type": "value",
          "value": "เอชเอ็น",
          "valueEN": "HN"
        },
        "name": {
          "type": "value",
          "value": "isHN"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "code",
          "value": "props.PatientSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "label",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ-สกุลผู้ป่วย",
          "valueEN": "Patient's name and surname"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-label-10"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "Label",
      "parent": 6,
      "props": {
        "children": {
          "type": "code",
          "value": "props.fullName || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-Label-11"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"max-content\", width: \"10rem\", padding:\"0.833em\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormField-12"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormField-13"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormField-14"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "label",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทผู้ป่วย",
          "valueEN": "Type of patient"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-label-15"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "label",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "คลินิก",
          "valueEN": "clinic"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-label-16"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "Dropdown",
      "parent": 12,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-Dropdown-17"
        },
        "name": {
          "type": "value",
          "value": "patientCase"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.patientCaseOptions || []"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", minWidth: \"max-content\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.patientCase || \"\""
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ClinicSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormField-19"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormField-20"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormField-21"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "label",
      "parent": 19,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภท Visit",
          "valueEN": "Visit Type"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-label-22"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "Checkbox",
      "parent": 20,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filter?.isOPD || false"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-Checkbox-23"
        },
        "label": {
          "type": "value",
          "value": "ผู้ป่วยนอก",
          "valueEN": "OPD"
        },
        "name": {
          "type": "value",
          "value": "isOPD"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "Checkbox",
      "parent": 21,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filter?.isIPD || false"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-Checkbox-24"
        },
        "label": {
          "type": "value",
          "value": "ผู้ป่วยใน",
          "valueEN": "IPD"
        },
        "name": {
          "type": "value",
          "value": "isIPD"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormField-25"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "Button",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": "ล้างการค้นหา",
          "valueEN": "Clear search"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-Button-26"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClear"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"max-content\"}"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormGroup-27"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormField-28"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormField-29"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormField-30"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormField-31"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormField-32"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormField-33"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormField-34"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormField-35"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormField-36"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "Checkbox",
      "parent": 28,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filter?.isDoctor ||false"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-Checkbox-37"
        },
        "label": {
          "type": "value",
          "value": "แพทย์เจ้าของไข้",
          "valueEN": "The attending physician"
        },
        "name": {
          "type": "value",
          "value": "isDoctor"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", minWidth: \"max-content\"}"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "div",
      "parent": 29,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DoctorSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-div-38"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 31,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DiagnosisSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "label",
      "parent": 32,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่",
          "valueEN": "date"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-label-41"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"max-content\"}"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "label",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-label-43"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormField-45"
        },
        "inline": {
          "type": "value",
          "value": "true"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormField-46"
        },
        "inline": {
          "type": "value",
          "value": "true"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-FormField-47"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-div-53"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 54,
      "name": "Table",
      "parent": 53,
      "props": {
        "data": {
          "type": "code",
          "value": "props.orderItems || []"
        },
        "headers": {
          "type": "value",
          "value": "วันที่รับเข้า,คลินิก/Ward,HN (VN/AN),ชื่อ-นามสกุล,ประเภทผู้ป่วย,ประเภท Visit, แพทย์เจ้าของใข้,Diagnosis"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-Table-54"
        },
        "keys": {
          "type": "value",
          "value": "encounter_datetime,division_name,hn_encounter_number,patient_fullname,patient_case_name,encounter_general_type,doctor_name,icd10_name"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"calc(100vh - 16rem)\", display: props.showStatistic ? \"none\": \"\"}"
        },
        "widths": {
          "type": "value",
          "value": "120"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "div",
      "parent": 35,
      "props": {
        "children": {
          "type": "code",
          "value": "props.EndDate"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-div-56"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 33,
      "props": {
        "children": {
          "type": "code",
          "value": "props.StartDate"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-div-57"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "div",
      "parent": 36,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-div-58"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "div",
      "parent": 45,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonPrint"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-div-59"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "div",
      "parent": 46,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonStatistic"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-div-60"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 47,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonStatisticPrint"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-div-61"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 62,
      "name": "Table",
      "parent": 53,
      "props": {
        "data": {
          "type": "code",
          "value": "props.statItems || []"
        },
        "headers": {
          "type": "value",
          "value": "ลำดับ,แพทย์เจ้าของไข้,ประเภทผู้ป่วย,ประเภท Visit,Diagnosis, จำนวน"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-Table-62"
        },
        "keys": {
          "type": "value",
          "value": "no,doctor_name,patient_case_name,encounter_general_type,icd10_name, encounter_count"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"calc(100vh - 16rem)\", display: props.showStatistic ? \"\": \"none\"}"
        },
        "widths": {
          "type": "value",
          "value": "100,auto,auto,auto,auto,150"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "Checkbox",
      "parent": 30,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filter?.isDiagnosis ||false"
        },
        "id": {
          "type": "value",
          "value": "CardReportPatientListUX-Checkbox-63"
        },
        "label": {
          "type": "value",
          "value": "การวินิจฉัย",
          "valueEN": "Diagnosis"
        },
        "name": {
          "type": "value",
          "value": "isDiagnosis"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", minWidth: \"max-content\"}"
        }
      },
      "seq": 63,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": true,
  "name": "CardReportPatientListUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
